import './App.css';
import React from 'react';
import MOTKPAGE from './GamePages/Mark_Of_the_Knights_page';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WorkInProg from './GamePages/WorkInProgressPage';
import QrCodeGeneratorPage from './Tools/QrCodeGeneratorPage';
import AdminPage from './Admin/AdminPage';
import { SiteContentProvider } from './Content/SiteContentContext';

function App(): JSX.Element {
  // basename follows package.json "homepage", so the routes keep working if the
  // site is served from a subfolder rather than the domain root. It is an empty
  // string when the site is at the root.
  return (
    <SiteContentProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<WorkInProg />} />
          <Route path="/MOTK" element={<MOTKPAGE />} />
          {/* Unlisted internal tool - deliberately not linked from anywhere. */}
          <Route path="/roya-url" element={<QrCodeGeneratorPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Router>
    </SiteContentProvider>
  );
}

export default App;
